import React, { useEffect, useContext } from 'react';
import { SaveCardModal } from '@thd-olt-component-react/consumer-card-messaging';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { CustomerAccountNavigation, useAccountCrumbs, } from '@thd-olt-component-react/customer-account-navigation';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useNavigate, useLocation } from '@thd-olt-component-react/router';
import { useInterceptors } from '../hooks/use-interceptors';
import { Alert } from '../components/shared/alert/alert';
import { PageTitle } from '../components/shared/page-title';
import { PaymentsContent } from '../components/payments/payments-content/payments-content';
import { mapCrumbsToStaticCrumbs, } from '../utils/breadcrumbs';
import { LoyaltyMembershipDetailsProvider } from '../contexts/loyalty-membership-details-context';
import { usePayments } from '../hooks/use-payments';
import { PAYMENT_FORM_MODE } from '../models/common/payments';
import { TAlertStatus } from '../models/common/alert-messages';
import { ERR_BULK_ADD_NOT_AVAILABLE, ERR_IC_NOT_AVAILABLE_FOR_PRO_ACCOUNTS, } from '../constants/response-error-messages';
const crumbs = [
    {
        label: 'Cards & Accounts',
        path: '/myaccount/payments',
    },
];
const PaymentsPageContent = ({ customerType, customerRole, }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { redirectError } = useInterceptors();
    const { isConsumerApp } = useContext(ExperienceContext);
    const { creditCardForm, setAlertMessage } = usePayments();
    const hdWalletFormMode = creditCardForm.mode === PAYMENT_FORM_MODE.AUTH_HD_WALLET_CREDIT_CARD;
    const notShowPagetitle = isConsumerApp && hdWalletFormMode;
    const staticCrumbs = mapCrumbsToStaticCrumbs(useAccountCrumbs(crumbs));
    useEffect(() => {
        if (!state)
            return;
        const { hasICAccessErrorState, hasBulkAddAccessError } = state;
        let errorMessage = null;
        if (hasICAccessErrorState) {
            errorMessage = ERR_IC_NOT_AVAILABLE_FOR_PRO_ACCOUNTS.message;
        }
        else if (hasBulkAddAccessError) {
            errorMessage = ERR_BULK_ADD_NOT_AVAILABLE.message;
        }
        if (errorMessage) {
            setAlertMessage({
                alertStatus: TAlertStatus.ERROR,
                text: errorMessage,
            });
        }
        window.history.replaceState({}, '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);
    const openAddCard = () => {
        navigate('/myaccount/payments/addcreditcard');
    };
    return (React.createElement("div", { className: "grid isBound" },
        React.createElement("div", { className: "col__12-12" },
            React.createElement(ErrorBoundary, { name: "save-card-modal" },
                React.createElement(SaveCardModal, { openAddCard: openAddCard })),
            redirectError ? (React.createElement("div", { className: "sui-pt-8" },
                React.createElement(Alert, { status: "info" }, redirectError.message))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-grid sui-gap-3 sui-py-3" },
                    !isConsumerApp && (React.createElement(ErrorBoundary, { name: "breadcrumbs" },
                        React.createElement(Breadcrumbs, { staticCrumbs: staticCrumbs }))),
                    !notShowPagetitle && (React.createElement(PageTitle, { title: "CARDS & ACCOUNTS", dataTestId: "payments-title" }))),
                React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-py-3" },
                    React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3" },
                        React.createElement(ErrorBoundary, { name: "customer-account-navigation" },
                            React.createElement(CustomerAccountNavigation, null))),
                    React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-9" },
                        React.createElement(ErrorBoundary, { name: "payments-content" },
                            React.createElement(LoyaltyMembershipDetailsProvider, null,
                                React.createElement(PaymentsContent, { customerType: customerType, customerRole: customerRole }))))))))));
};
PaymentsPageContent.dataModel = extend(CustomerAccountNavigation, LoyaltyMembershipDetailsProvider, Breadcrumbs);
PaymentsPageContent.displayName = 'PaymentsPageContent';
export const Payments = ({ customerType, customerRole, }) => {
    return (React.createElement(QueryProvider, { defaultVariables: {
            channelId: 1,
        }, cacheKey: "payments-page" },
        React.createElement(PaymentsPageContent, { customerType: customerType, customerRole: customerRole })));
};
Payments.displayName = 'Payments';
